import { render, staticRenderFns } from "./Liquidar.vue?vue&type=template&id=500f2686&"
import script from "./Liquidar.vue?vue&type=script&lang=js&"
export * from "./Liquidar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports